import * as msTeams from "@microsoft/teams-js";

declare global {
  namespace teamsentry {
    export type ActionType = 'redirect' | undefined
    export type ActionPayload = RedirectActionPayload | undefined | null

    export interface Payload {
      action: ActionType
      payload: ActionPayload
    }

    /**
     * Redirect Action Payload
     * @description 팀즈앱 내부에서 redirect action을 수행해야할 때 사용되는 payload입니다.
     * @property relativeUrl query string을 포함한 상대경로
     * @example /po/home?tab=tab1
     */
    export interface RedirectActionPayload {
      relativeUrl: string
    }
  }
}

export default class TeamsHelper {
  private tenantId = '6fa75e6f-8a8b-4b10-8a3b-99d22acbb04e';
  private appId = '4d872d9d-140d-4ed1-a4a4-0969b2587fab';
  private entityId = '8276fc8e-85da-4861-8600-73510069a785';
  private deepLinkBase = `msteams://teams.microsoft.com/entity`;
  private deepLinkBaseUrl = `${this.deepLinkBase}/${this.appId}/${this.entityId}?tenantId=${this.tenantId}`;

  /**
   * @description TeamsHelper 생성자
   * @param tenantId 테넌트 아이디
   * @param appId 팀즈앱 아이디
   * @param entityId 팀즈앱 엔티티 아이디
   * @param deepLinkBase 팀즈앱 deepLinkBase
   * @example
   * const teamsHelper = new TeamsHelper('6fa75e6f-8a8b-4b10-8a3b-99d22acbb04e', '4d872d9d-140d-4ed1-a4a4-0969b2587fab', '8276fc8e-85da-4861-8600-73510069a785', 'msteams://teams.microsoft.com/entity');
   * const teamsHelper = new TeamsHelper('6fa75e6f-8a8b-4b10-8a3b-99d22acbb04e', '4d872d9d-140d-4ed1-a4a4-0969b2587fab', '8276fc8e-85da-4861-8600-73510069a785');
   * const teamsHelper = new TeamsHelper('6fa75e6f-8a8b-4b10-8a3b-99d22acbb04e', '4d872d9d-140d-4ed1-a4a4-0969b2587fab');
   * const teamsHelper = new TeamsHelper('6fa75e6f-8a8b-4b10-8a3b-99d22acbb04e');
   * const teamsHelper = new TeamsHelper();
   * @returns TeamsHelper
  */
  constructor(tenantId?: string, appId?: string, entityId?: string, deepLinkBase?: string) {
    if (tenantId)
      this.tenantId = tenantId;

    if (appId)
      this.appId = appId;

    if (entityId)
      this.entityId = entityId;


    if (deepLinkBase?.endsWith('/')) {
      deepLinkBase = deepLinkBase.slice(0, -1);
      this.deepLinkBase = deepLinkBase;
    }

    this.deepLinkBaseUrl = `${this.deepLinkBase}/${this.appId}/${this.entityId}?tenantId=${this.tenantId}`;
  }

  /**
   * @description 팀즈앱의 subEntityId를 가져옵니다.
   * @returns teamsentry.Payload
   */
  uGetTeamsSubEntityIdObj = async () => {
    let subEntityId = '';
    let isTeams = false;

    try {
      await msTeams.initialize(() => {
        isTeams = true;
      })

      await new Promise<string>((resolve, reject) => {
        msTeams.getContext((context: any) => {
          if (context?.subEntityId) {
            resolve(context.subEntityId);
          } else {
            reject(null);
          }
        });
      }).then((result) => { subEntityId = result; });

      if (!subEntityId) {
        throw new Error('Teams Helper: subEntityId is not exist.');
      }

      let deserializeObj = JSON.parse(JSON.parse(JSON.stringify(atob(subEntityId))));
      console.error('deserializeObj: ', deserializeObj);

      return deserializeObj as teamsentry.Payload;
    } catch (error) {
      console.error(error);
      return { action: undefined, payload: undefined };
    }
  }

  uGetTeamsDeepLink = (payload?: teamsentry.Payload) => {
    if (!payload) {
      return this.deepLinkBaseUrl;
    }

    let deepLinkURLObject = new URL(this.deepLinkBaseUrl);
    let contextObj = {
      subEntityId: btoa(JSON.stringify(payload))
    }
    deepLinkURLObject.searchParams.append('context', JSON.stringify(contextObj));

    return deepLinkURLObject.toString();
  }
}